import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    FetchGetDocumentTypesByServiceIdthunk, 
    FetchGetServicesRequestByIdthunk, 
    FetchGetCovCerByHorseIdthunk,
    FetchGetServiceDefinitionByIdthunk
} from "../../../../Redux/ServicesRequests/ServicesRequestsAction";
import { FetchOwnerHorsesDropDownthunk } from "../../../../Redux/OwnerProfile/OwnerProfileAction";
import { resetGetServicesRequestByIdData } from "../../../../Redux/ServicesRequests/ServicesRequestsSlice";
import { resetToasterMessage } from "../../../../Redux/HorseLeasing/horseLeasingSlice";

const HORSE_LEASING_SERVICE_ID = "B431A620-4E2C-4D20-8D03-DEF43F02E90B";

export const useHorseLeasingData = (id, selectedOwnerId, currentLanguage, action) => {
    const dispatch = useDispatch();

    const { ownerHorsesDropDownData } = useSelector((state) => state.ownerProfileSlice);
    const { isLoading, toasterMessage } = useSelector((state) => state.horseLeasingSlice);
    const { getDocumentTypesByServiceIdData, getServicesRequestByIdData, covCerByHorseIdData, getServiceDefinitionByIdData, servicesRequestsLoading } = useSelector((state) => state.servicesRequestsSlice);

    useEffect(() => {
        if (id) {
            dispatch(FetchGetServicesRequestByIdthunk({ id: id, ownerId: selectedOwnerId, language: currentLanguage }));
        }

        if (action !== "view" && action !== "approve") {
            dispatch(FetchOwnerHorsesDropDownthunk({
                ownerId: selectedOwnerId,
                skip: 0,
                take: 1000,
                langauge: currentLanguage,
                horseTypeFilter: "1",
                searchValue: "",
                sortBy: "-1",
                serviceDefinitionId: HORSE_LEASING_SERVICE_ID,
            }));

            dispatch(FetchGetDocumentTypesByServiceIdthunk({
                id: HORSE_LEASING_SERVICE_ID,
                language: currentLanguage,
            }));
        }

        dispatch(FetchGetServiceDefinitionByIdthunk(HORSE_LEASING_SERVICE_ID));

        return () => {
            dispatch(resetGetServicesRequestByIdData());
        };
    }, [id, currentLanguage, dispatch, selectedOwnerId]);

    const fetchCoveringCertificate = (horseId) => {
        dispatch(FetchGetCovCerByHorseIdthunk({ horseId, ownerId: selectedOwnerId }));
    };

    const clearToasterMessage = () => {
        dispatch(resetToasterMessage());
    };

    return {
        HORSE_LEASING_SERVICE_ID,
        ownerHorsesDropDownData,
        isLoading: isLoading || servicesRequestsLoading,
        toasterMessage,
        clearToasterMessage,
        getDocumentTypesByServiceIdData,
        getServicesRequestByIdData,
        getCovCerByHorseIdData: covCerByHorseIdData,
        getServiceDefinitionByIdData,
        fetchCoveringCertificate
    };
};
